import { MutableRefObject } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { buildPersonaSettingsPayload } from 'src/pages/ConfigurationPage/utils/buildPersonaSettingsPayload';

// Builds and dispatches the create/update request for either the persona
// form or the system-prompt form, guarding against double submission.
export const useConfigurationSubmit = ({
  systemPromptActive,
  formFieldsObject,
  inputData,
  isCreationMode,
  activeSettings,
  configurationSettingsPrompt,
  defaultTemplateFields,
  defaultWorkflows,
  customWorkflows,
  id,
  methods,
  createConfigurationSettings,
  updateConfigurationSettings,
  isSubmitting,
}: {
  systemPromptActive: boolean;
  formFieldsObject: Record<string, any>;
  inputData: any;
  isCreationMode: boolean;
  activeSettings: any;
  configurationSettingsPrompt: any;
  defaultTemplateFields: any;
  defaultWorkflows: any[];
  customWorkflows: any[];
  id: string;
  methods: UseFormReturn<any>;
  createConfigurationSettings: (args: any) => void;
  updateConfigurationSettings: (args: any) => void;
  isSubmitting: MutableRefObject<boolean>;
}) => {
  const submitPersonaForm = (formData: any) => {
    const payload = buildPersonaSettingsPayload(formData, formFieldsObject, inputData);
    const input_data = {
      ...payload,
      pf_default_workflow: defaultWorkflows[0],
      pf_custom_workflows: customWorkflows,
    };

    if (isCreationMode) {
      const body: Record<string, any> = { prompt: { input_data } };

      if (activeSettings?.is_deployed) {
        body.prompt.prompt_id = configurationSettingsPrompt.id;
      } else {
        body.prompt.template_id = defaultTemplateFields.id;
      }

      createConfigurationSettings({ id, body });
    } else {
      updateConfigurationSettings({
        project_id: id,
        settings_id: activeSettings.id,
        body: { input_data },
      });
    }
  };

  const submitSystemPromptForm = ({ text, selected_template_id, placeholder }: any) => {
    let prompt: any;

    methods.setValue('template_id', 'custom');

    if (selected_template_id) {
      prompt = {
        template_id: +selected_template_id,
        input_data: { [placeholder]: text },
      };
    } else if (configurationSettingsPrompt) {
      const promptPlaceholder = Object.keys(configurationSettingsPrompt.input_data)[0];

      prompt = {
        template_id: configurationSettingsPrompt.template_id,
        input_data: { [promptPlaceholder]: text },
      };
    }

    if (isCreationMode) {
      createConfigurationSettings({ id, body: { prompt } });
    } else {
      updateConfigurationSettings({
        project_id: id,
        settings_id: activeSettings.id,
        body: { ...prompt, text },
      });
    }
  };

  const submitForm = (formData: any) => {
    if (isSubmitting.current) {
      return;
    }

    isSubmitting.current = true;

    if (systemPromptActive) {
      submitSystemPromptForm(formData);
    } else {
      submitPersonaForm(formData);
    }
  };

  return { submitForm };
};
